import { Injectable } from '@angular/core';
import { appConfig } from 'src/app/config/app.config';
import { Employee } from 'src/app/models/Employees';
import { DateUtil } from 'src/app/util/date.util';
import { ToastService } from 'src/app/util/toast.service';

import { AuthService } from '../auth.service';
import { BackEndService } from '../backEnd.service';
import { AlertService } from 'src/app/util/alert.service';
import { WhatsappService } from '../whatsapp.service';
import { UtilityTs } from 'src/app/util/utilityTs';
import { LoaderService } from 'src/app/util/loader.service';
import { UserPd } from 'src/app/models/UserPd';

@Injectable({
  providedIn: 'root',
})
export class EmployeeSService {
  similarProfiles: Employee[] = [];
  employee: Employee = new Employee;
  employeeList: Employee[] = [];
  dateUtil = new DateUtil();

  private safeJsonParse(value: any, fallback: any = []): any {
    if (value === null || value === undefined) return fallback;
    if (typeof value !== 'string') return value;
    const trimmed = value.trim();
    if (trimmed === '' || trimmed === 'null' || trimmed === 'undefined') return fallback;
    try {
      return JSON.parse(trimmed);
    } catch (e) {
      console.warn('safeJsonParse failed for value:', value, e);
      return fallback;
    }
  }

  constructor(private backEnd: BackEndService, private auth: AuthService, private loader: LoaderService,
    private toast: ToastService, private alert: AlertService, private whatsapp: WhatsappService) {
  }


  saveUser(tableName, user) {
    return this.backEnd.saveObject(tableName, user);
  }

  findSimilarEmployees(emp) {
    return new Promise((resolve) => {
      this.loader.show();
      // resolve([]);
      const age = UtilityTs.getAge(emp.user.dob);
      console.log("my age", age, emp.user.dob);
      const yearLess = new Date(new Date().setFullYear(new Date().getFullYear() - (age - 5))).toISOString();
      const yearMore = new Date(new Date().setFullYear(new Date().getFullYear() - (age + 5))).toISOString();
      console.log("find similar ", emp)
      console.log(yearLess, yearMore, emp.user.dob);
      let filters: any[] = [
        ["user.name", "%" + emp.user.name + "%", "ilike"],
        ["user.gender", emp.user.gender],
        ["user.dob", yearMore, ">"],
        ["user.dob", yearLess, "<"],
        ["user.user_pd.business_id", this.auth.business.id],
      ];
      this.searchEmp(filters, 0, 20, 'created_at', true).then((response) => {
        resolve(response);
        this.loader.hide();
      })
    })
  }

  saveObject(employee?: Employee, toast?: boolean) {
    this.loader.show();

    employee = employee ?? this.employee;
    toast = toast ?? true;
    return new Promise((resolve) => {
      if (!employee.id) {
        employee.user_id = employee.user_id ?? this.auth.loggedInEmployee.user.id;
      }
      employee.created_by = employee.created_by ?? this.auth.loggedInEmployee.id;
      this.backEnd.saveObject("employee", employee).then((response) => {
        if (response) {
          if (toast) {
            this.toast.success("Your employee is submitted successfully. We will contact you soon");
          }
          resolve(true);
          this.loader.hide();
        } else {
          resolve(false);
          this.loader.hide();
        }
      });
    });
  }

  async getUserOfEmployee() {
    let userList = await this.backEnd.searchObject("user", [["id", this.employee.user_id]], 0, 20, 'created_at', true, "user_pd:user_pd_user_id_fkey(*)");
    // console.log(userList)
    // this.supa.getSingle("user", [["id", this.employee.user_id]]).then((userList: User[]) => {
    if (userList && userList.length == 1 && userList[0].user_pd) {
      userList[0].user_pd = userList[0].user_pd[0];
      this.employee.user = userList[0];
    }
    // });
  }

  getEmpByVariable(variable, value) {
    return new Promise<Employee>((resolve) => {

      this.backEnd.getSingle("employee", [[variable, value]], "user:user_id!inner(*, user_pd:user_pd_user_id_fkey!inner(*))").then((employee) => {
        if (employee) {
          if (employee.user.user_pd && employee.user.user_pd.length > 0) {
            employee.user.user_pd = employee.user.user_pd[0];
          }
          if (employee.user.dob && (typeof employee.user.dob === 'string' || employee.user.dob instanceof String)) {
            employee.user.dob = new Date(employee.user.dob);
          }
          console.log(employee);
          employee.access = this.safeJsonParse(employee.access, []);
          employee.assigned_area = this.safeJsonParse(employee.assigned_area, []);
          if (employee.user?.user_pd) {
            employee.user.user_pd.achievement = this.safeJsonParse(employee.user.user_pd.achievement, []);
            employee.user.user_pd.tag = this.safeJsonParse(employee.user.user_pd.tag, []);
          }
          resolve(employee);
          this.loader.hide();
        }
        else {
          resolve(null)
          this.loader.hide();
        }
      });
    });

  }

  getCount(tableName, base, query) {
    return new Promise<number>((resolve) => {
      this.backEnd.countObject(tableName, query, base).then((response) => {
        console.log(response);
        resolve(response);
      });
    });
  }
  searchEmp(query, index, limit, orderBy, reverse) {
    return new Promise((resolve) => {
      this.loader.show();
      // let extraKey = "user!user_id(*,user_pd!user_pd_user_id_fkey(*))";
      let extraKey = 'user:user_id!inner(*,user_pd:user_pd_user_id_fkey!inner(*))';
      // let extraKey = 'user:user_id!inner(*,user_pd(*)),user.user_pd(*)';
      this.backEnd.searchObject("employee", query, index, limit, orderBy, reverse, extraKey).then((employeeList) => {
        if (employeeList) {
          for (let employee of employeeList) {
            if (employee.user.user_pd && employee.user.user_pd.length > 0) {
              employee.user.user_pd = employee.user.user_pd[0];
            }
            employee.access = this.safeJsonParse(employee.access, []);
            employee.assigned_area = this.safeJsonParse(employee.assigned_area, []);
            if (employee.user?.user_pd) {
              employee.user.user_pd.achievement = this.safeJsonParse(employee.user.user_pd.achievement, []);
              employee.user.user_pd.tag = this.safeJsonParse(employee.user.user_pd.tag, []);
            }
          }
          resolve(employeeList);
          this.loader.hide();
        }
        else {
          resolve(null)
          this.loader.hide();
        }
      });
    });

  }
  private async delete(id, table?) {
    table = table ?? appConfig.STORAGE_TABLE.EMPLOYEE;
    return await this.backEnd.deleteObject(table, id)
  }

  deleteEmployee(emp) {
    return new Promise((resolve) => {
      this.loader.show();
      this.delete(emp.id).then((res) => {
        console.log("Employee deleted successfully", res);
        this.delete(emp.user.user_pd.id, appConfig.STORAGE_TABLE.UserPd).then((res2) => {
          console.log("UserPd deleted successfully", res2);
          this.delete(emp.user_id, appConfig.STORAGE_TABLE.USER).then((res3) => {
            console.log("User deleted successfully", res3);
            resolve(true);
            this.loader.hide();
          })
        });
      })
    })
  }

  getAssignedMemberList(business_id) {
    return new Promise((resolve) => {
      this.searchEmp([["business_id", business_id], ["assigned_area", null, "!="]], 0, 10000, "assigned_area", false).then((employeeList) => {
        resolve(employeeList)
      });
    });
  }

  empValidation(emp: Employee): boolean {
    if (emp.user.user_pd.occupation == 'Other') {
      emp.user.user_pd.occupation = emp.user.user_pd.other_occupation
    }
    if (emp.user.user_pd.education == 'Other') {
      emp.user.user_pd.education = emp.user.user_pd.other_education
    }
    if (emp.user.user_pd.profession == 'Other') {
      emp.user.user_pd.profession = emp.user.user_pd.other_profession
    }
    delete emp.user.user_pd.other_profession
    delete emp.user.user_pd.other_education
    delete emp.user.user_pd.other_occupation

    let valid = true;
    if (!emp.user.gender) {
      valid = false;
      this.toast.error('Gender is mandatory');
    }
    if (this.auth.business && this.auth.business.category && !emp.user.user_pd.sub_community) {
      valid = false;
      this.toast.error('Sub-Community is mandatory');
    }
    if (!emp.user.user_pd.marital) {
      valid = false;
      this.toast.error('Marital Status is mandatory');
    }
    if (!emp.user.dob) {
      valid = false;
      this.toast.error('Please enter valid date of birth');
    }
    if (emp.user.user_pd.mobile && emp.user.user_pd.mobile.length > 0 &&
      (emp.user.user_pd.mobile.length < 5 || emp.user.user_pd.mobile.length > 15)) {
      valid = false;
      this.toast.error('Please enter a valid mobile number');
    }
    if (!emp.user.user_pd.origin_city) {
      valid = false;
      this.toast.error('Origin city is mandatory');
    }
    if (!emp.user.user_pd.current_address2) {
      valid = false;
      this.toast.error('Address selection through pincode is mandatory');
    }
    if (!emp.user.name) {
      valid = false;
      this.toast.error('Name is mandatory');
    }
    if (!valid) {
      this.loader.hideForce();
    }
    return valid;
  }

  clickApprove(emp: Employee) {
    this.alert.show3ButtonAlert('Verify', 'Are you sure you have verified this member?', 'Verify', 'Reject', 'Cancel').then((value) => {
      if (value == 1) {
        emp.user.user_pd.status = 'Verified';
        emp.manager_id = this.auth.loggedInEmployee.id;
        this.saveUser(appConfig.STORAGE_TABLE.UserPd, emp.user.user_pd).then(() => {
          this.saveObject(emp, false).then(() => {
            this.toast.success("Member approved successfully");
            this.whatsapp.sendMessage(emp.user.user_pd.mobile, "*Your Profile is Now Verified!* ✅\n\n" +
              "Welcome to the " + this.auth.business.name + "!\n" +
              "Verification helps us ensure that every member truly belongs here and maintains the integrity of our community.\n\n" +

              "By verifying your profile:\n\n" +

              "We confirm that you're a genuine member of our community.\n" +

              "You gain full access to features and interactions within the app.\n" +

              "We also take this opportunity to guide you through the key features and how to make the best use of the app.\n\n" +

              "Let’s continue building a stronger, trusted community—together!\n")
          })
        })
      } else if (value == 2) {
        this.alert.showTextAlert('Reject', 'Please provide reason for rejection. On Page reload it will be removed from this list', 'Reason', 'Reject').then((reason) => {
          if (reason) {
            emp.user.user_pd.status = 'Rejected';
            emp.user.user_pd.caste = reason;
            emp.business_id = "Vanshavali";
            emp.user.user_pd.business_id = "Vanshavali";
            this.saveUser(appConfig.STORAGE_TABLE.UserPd, emp.user.user_pd).then(() => {
              this.saveObject(emp, false).then(() => {
                this.toast.success("Member rejected successfully");
                this.employeeList = this.employeeList.filter(e => e.id !== emp.id);
              })
            })
          }
        })
      }
    })
  }
  async findAreaManger(user_pd: UserPd) {
    let searchOrder = [
      { location: user_pd.area, type: 'Area' },
      { location: user_pd.town, type: 'Town' },
      { location: user_pd.district, type: 'District' },
      { location: user_pd.state, type: 'State' },
      { location: user_pd.country, type: 'Country' }
    ];

    for (let search of searchOrder) {
      if (search.location) {
        let empList: any = await this.searchEmp([
          ['assigned_area', "%" + search.location + "%", 'like'],
          ["business_id", user_pd.business_id]
        ], 0, 100, "created_at", false);

        if (empList && empList.length > 0) {
          console.log(`Found ${empList.length} manager(s) for ${search.type}: ${search.location}`);
          return empList;
        } else {
          console.log(`No manager found for ${search.type}: ${search.location}`);
          console.log('Nothing', empList);
        }
      }
    }
    console.log('No area manager found for any location level');
    return [];
  }
  async findMemberByMobile(mobile: any) {
    let mobileFilter = mobile;
    if (mobile && !mobile.startsWith("+")) {
      mobileFilter = '+' + mobile;
    }

    try {
      console.log('searching for ' + mobileFilter);
      const extraKey = "user:user_id!inner(*, user_pd:user_pd_user_id_fkey!inner(*)), business:business_id(*)";
      const results: any = await this.backEnd.searchObject(
        "employee", [["user.user_pd.mobile", mobileFilter]], 0, 1, undefined, undefined,
        extraKey
      );

      if (results && results.length > 0) {
        let employee = results[0];
        if (Array.isArray(employee.user)) {
          employee.user = employee.user[0];
        }
        if (employee.user) {
          if (Array.isArray(employee.user.user_pd) && employee.user.user_pd.length > 0) {
            employee.user.user_pd = employee.user.user_pd[0];
          } else if (Array.isArray(employee.user.user_pd) && employee.user.user_pd.length === 0) {
            // Fallback if inner join somehow failed or returned empty but still matched row
            employee.user.user_pd = new UserPd();
          } else if (!employee.user.user_pd) {
            employee.user.user_pd = new UserPd();
          }
        }
        console.log('[AuthService] findMemberByMobile mapped result:', JSON.stringify(employee));
        return employee;
      } else {
        console.log('[AuthService] findMemberByMobile not found');
        return null;
      }
    } catch (err) {
      console.error('[AuthService] findMemberByMobile error:', err);
      return null;
    }
  }


}
